module.exports = __webpack_public_path__ + "img/098-wolf.1eff99fb.svg";